// VFX: Matrix Code Rain
// Category: particle-systems · Tags: background, matrix, code, rain, tech
// Colunas de caracteres caindo estilo Matrix. Verde sobre preto.
import { AbsoluteFill, useCurrentFrame } from "remotion";
import React from "react";

const CHARS = "アイウエオカキクケコ0123456789ABCDEF";
const COLUMNS = 22;
const CHAR_H = 28;
const ROW_COUNT = 36;
const GLOW = "#10b981";

export default function BgMatrixRainCodeLoop() {
  const frame = useCurrentFrame();
  return (
    <AbsoluteFill style={{ background: "#000000", overflow: "hidden" }}>
      {Array.from({ length: COLUMNS }, (_, col) => {
        const speed = 0.8 + (col % 5) * 0.35;
        const offset = (col * 17) % ROW_COUNT;
        const topChar = Math.floor((frame * speed + offset) % ROW_COUNT);
        return (
          <div key={col} style={{ position: "absolute", left: `${(col / COLUMNS) * 100}%`, top: 0, width: `${100 / COLUMNS}%` }}>
            {Array.from({ length: ROW_COUNT }).map((_, row) => {
              const charIndex = (frame * 2 + col * 7 + row * 3) % CHARS.length;
              const isHead = row === topChar % ROW_COUNT;
              const distFromHead = Math.abs(row - (topChar % ROW_COUNT));
              const opacity = isHead ? 1 : Math.max(0, 1 - distFromHead * 0.1);
              return (
                <div key={row} style={{
                  color: isHead ? "#f8fafc" : GLOW,
                  fontSize: 18, fontFamily: "monospace", textAlign: "center",
                  height: CHAR_H, opacity, lineHeight: `${CHAR_H}px`,
                  textShadow: isHead ? `0 0 10px ${GLOW}` : "none",
                }}>{CHARS[charIndex]}</div>
              );
            })}
          </div>
        );
      })}
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
